<template>
  <div id="appointment-sms-content" class="rounded-item shadow-md">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <h4 class="text-2xl font-bold mb-6">SMS Content</h4>
            <!-- <div v-if="smsContent">
              <vs-row class="mb-6">
                <vs-col vs-w="4" class="pr-6">
                  <span class="font-bold">SMS sent when your customer completes a booking online</span>
                </vs-col>
                <vs-col vs-w="7">
                  <span class="break-word">{{smsContent[scheduled_key]}}</span>
                </vs-col>
                <vs-col vs-w="1">
                  <feather-icon icon="Edit2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="openEditPopup(scheduled_key, smsContent[scheduled_key])"/>
                </vs-col>
              </vs-row>

              <vs-row class="mb-6">
                <vs-col vs-w="4" class="pr-6">
                  <span class="font-bold">SMS sent when customer’s booking is confirmed</span>
                </vs-col>
                <vs-col vs-w="7">
                  <span class="break-word">{{smsContent[confirmed_key]}}</span>
                </vs-col>
                <vs-col vs-w="1">
                  <feather-icon icon="Edit2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="openEditPopup(confirmed_key, smsContent[confirmed_key])"/>
                </vs-col>
              </vs-row>

              <vs-row class="mb-6">
                <vs-col vs-w="4" class="pr-6">
                  <span class="font-bold">SMS sent when your customer cancels a booking</span>
                </vs-col>
                <vs-col vs-w="7">
                  <span class="break-word">{{smsContent[canceled_key]}}</span>
                </vs-col>
                <vs-col vs-w="1">
                  <feather-icon icon="Edit2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="openEditPopup(canceled_key, smsContent[canceled_key])"/>
                </vs-col>
              </vs-row>

              <vs-row class="mb-6">
                <vs-col vs-w="4" class="pr-6">
                  <span class="font-bold">SMS sent reminder customer</span>
                </vs-col>
                <vs-col vs-w="7">
                  <span class="break-word">{{smsContent[remind_key]}}</span>
                </vs-col>
                <vs-col vs-w="1">
                  <feather-icon icon="Edit2Icon" svgClasses="w-5 stroke-current ml-4 cursor-pointer icon-group" @click="openEditPopup(remind_key, smsContent[remind_key])"/>
                </vs-col>
              </vs-row>


              <vs-popup class="holamundo" title="Edit SMS Content" :active.sync="popupActive">
                <div class="flex align-center">
                  <vs-textarea :maxlength="160" counter="160" v-model="editData.content" />
                </div>
                <div class="w-full flex justify-end mt-4">
                  <vs-button @click="updateSMSContent">Save</vs-button>
                </div>
              </vs-popup>
            </div> -->
            <div v-if="smsContent">
              <div>
                <h6 class="mb-2 mt-6 font-bold">SMS sent when your customer completes a booking online</h6>
                <div class="flex align-center">
                  <vs-textarea class="mb-0" :maxlength="160" id="scheduled-content-textarea" v-model="scheduled_content" />
                  <vs-icon v-if="scheduled_edited" icon="check_circle" size="medium" color="primary" @click.stop="saveChanges('scheduled')"
                  class="cursor-pointer user-select-none vs-con-loading__container ml-5 save-add-animation"></vs-icon>
                </div>
              </div>

              <div>
                <h6 class="mb-2 mt-6 font-bold">SMS sent when customer’s booking is confirmed</h6>
                <div class="flex align-center">
                  <vs-textarea class="mb-0" :maxlength="160" id="confirmed-content-textarea" v-model="confirmed_content" />
                  <vs-icon v-if="confirmed_edited" icon="check_circle" size="medium" color="primary" @click.stop="saveChanges('confirmed')"
                  class="cursor-pointer user-select-none vs-con-loading__container ml-5 save-add-animation"></vs-icon>
                </div>
              </div>

              <div>
                <!-- <h6 class="mb-2 mt-6 font-bold">SMS sent when your customer cancels a booking</h6> -->
                <h6 class="mb-2 mt-6 font-bold">SMS sent when you can't fulfill an appointment request</h6>
                <div class="flex align-center">
                  <vs-textarea class="mb-0" :maxlength="160" id="canceled-content-textarea" v-model="canceled_content" />
                  <vs-icon v-if="canceled_edited" icon="check_circle" size="medium" color="primary" @click.stop="saveChanges('canceled')"
                  class="cursor-pointer user-select-none vs-con-loading__container ml-5 save-add-animation"></vs-icon>
                </div>
              </div>

              <div>
                <h6 class="mb-2 mt-6 font-bold">SMS sent reminder customer</h6>
                <div class="flex align-center">
                  <vs-textarea class="mb-0" :maxlength="160" id="remind-content-textarea" v-model="remind_content" />
                  <vs-icon v-if="remind_edited" icon="check_circle" size="medium" color="primary" @click.stop="saveChanges('remind')"
                  class="cursor-pointer user-select-none vs-con-loading__container ml-5 save-add-animation"></vs-icon>
                </div>
              </div>

              <div>
                <h6 class="mb-2 mt-6 font-bold">SMS sent for waiting customer</h6>
                <div class="flex align-center">
                  <vs-textarea class="mb-0" :maxlength="160" id="waiting-customer-content-textarea" v-model="waiting_customer_content" />
                  <vs-icon v-if="waiting_customer_edited" icon="check_circle" size="medium" color="primary" @click.stop="saveChanges('waiting_customer')"
                  class="cursor-pointer user-select-none vs-con-loading__container ml-5 save-add-animation"></vs-icon>
                </div>
              </div>
            </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  name: 'vs-appointment-sms-content',
  data(){
    return{
    //   key_active: false,
    //   type_err: '',
      textarea: '',
      popupActive : false,

      scheduled_key: 'config.appointment.content_sms.customer.scheduled',
      confirmed_key: 'config.appointment.content_sms.customer.confirmed',
      canceled_key : 'config.appointment.content_sms.customer.canceled',
      remind_key   : 'config.appointment.remind_content',
      waiting_customer_key: 'config.gocheckin.sms_for_waiting_customer_content',

      scheduled_content: '',
      confirmed_content: '',
      canceled_content: '',
      remind_content: '',
      waiting_customer_content: '',

      isLoaded: false,

      scheduled_edited: false,
      confirmed_edited: false,
      canceled_edited: false,
      remind_edited: false,
      waiting_customer_edited: false,

      editData: {
        key: '',
        content: ''
      },
      loaded_data_num: 0,
      action_type: ''
    }
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = 'Get Data';
          this.openLoadingInDiv();
        }
      }
    },
    scheduled_content: {
      immediate: true,
      handler() {
        if(this.isLoaded) {
          this.scheduled_edited = true;
        }
        this.setAutoHeight('scheduled-content-textarea');
      }
    },
    confirmed_content: {
      immediate: true,
      handler() {
        if(this.isLoaded) {
          this.confirmed_edited = true;
        }
        this.setAutoHeight('confirmed-content-textarea');
      }
    },
    canceled_content: {
      immediate: true,
      handler() {
        if(this.isLoaded) {
          this.canceled_edited = true;
        }
        this.setAutoHeight('canceled-content-textarea');
      }
    },
    remind_content: {
      immediate: true,
      handler() {
        if(this.isLoaded) {
          this.remind_edited = true;
        }
        this.setAutoHeight('remind-content-textarea');
      }
    },
    waiting_customer_content: {
      immediate: true,
      deep: true,
      handler() {
        if(this.isLoaded) {
          this.waiting_customer_edited = true;
        }
        this.setAutoHeight('waiting-customer-content-textarea');
      }
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: 'danger',
            title: 'Notification',
            text: this.action_type + ' SMS Content Failed',
            acceptText: 'OK'
          })
        }
      }, 10000);
    },
    closeLoading() {
      this.isOpenLoading = false;
      setTimeout( ()=> {
        this.$vs.loading.close('#app > .con-vs-loading')
      }, 500);
    },
    openEditPopup(key, content) {
      this.editData.key = key;
      this.editData.content = content;
      this.popupActive = true;
    },
    saveChanges(type) {
      if(type == 'scheduled') {
        this.editData.key = this.scheduled_key;
        this.editData.content = this.scheduled_content;
        this.scheduled_edited = false;
      } else if(type == 'confirmed') {
        this.editData.key = this.confirmed_key;
        this.editData.content = this.confirmed_content;
        this.confirmed_edited = false;
      } else if(type == 'canceled') {
        this.editData.key = this.canceled_key;
        this.editData.content = this.canceled_content;
        this.canceled_edited = false;
      } else if(type == 'remind') {
        this.editData.key = this.remind_key;
        this.editData.content = this.remind_content;
        this.remind_edited = false;
      } else if(type == 'waiting_customer') {
        this.editData.key = this.waiting_customer_key;
        this.editData.content = this.waiting_customer_content;
        this.waiting_customer_edited = false;
      }
      this.updateSMSContent();
    },
    updateSMSContent() {
      let obj = {
        key: this.editData.key,
        value: this.editData.content
      }
      this.action_type = 'Update';
      this.openLoadingInDiv();
      this.$store.dispatch("appSetting/UPDATE_SMS_CONTENT", obj).then(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Update SMS Content Success',
          color:'success',
          position:'top-right'})
        this.popupActive = false;
      }).catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title:'Notification',
          text:'Update SMS Content Failed',
          color:'danger',
          position:'top-right'})
        this.popupActive = false;
      })
    },
    setAutoHeight(id) {
      let elem = document.getElementById(id);
      if (elem) {
        elem.style.height = "auto";
        elem.style.maxHeight = 43 + 'px';
        if(elem.scrollHeight > 43) {
          elem.style.maxHeight = 'unset';
        }
        elem.style.height = elem.scrollHeight + "px";
      }
    },
  },
  computed: {
    smsContent() {
      return this.$store.getters['appSetting/smsContent'];
    }
  },
  created(){
    this.$store.dispatch("appSetting/GET_SMS_CONTENT").then(() => {
      this.loaded_data_num++;
      let sms_content = this.$store.getters['appSetting/smsContent'];
      this.scheduled_content = sms_content[this.scheduled_key];
      this.confirmed_content = sms_content[this.confirmed_key];
      this.canceled_content = sms_content[this.canceled_key];
      this.remind_content = sms_content[this.remind_key];
      this.waiting_customer_content = sms_content[this.waiting_customer_key];

      
      setTimeout(() => {
        this.isLoaded = true;
        this.setAutoHeight('scheduled-content-textarea');
        this.setAutoHeight('confirmed-content-textarea');
        this.setAutoHeight('canceled-content-textarea');
        this.setAutoHeight('remind-content-textarea');
        this.setAutoHeight('waiting-customer-content-textarea');
      }, 500);
    });
  }
}
</script>